import {
  SYSTEM_EDU_MODAL_CHANGE,
} from './constants';

export function eduModalChange(visible,type) {
  return {
    type: SYSTEM_EDU_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_EDU_MODAL_CHANGE:
      return {
        ...state,
        eduModalType:action.data.type,
        eduModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/eduModalChange.js